import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";

const styles = {
  label: {
    whiteSpace: "nowrap"
  }
};

const AreaChooser = props => {
  const inputLabel = React.useRef(null);

  const [labelWidth, setLabelWidth] = React.useState(0);

  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <form className="chooser">
      <FormControl variant="outlined" component="div">
        <InputLabel
          ref={inputLabel}
          htmlFor={props.id}
          classes={{
            root: props.classes.label
          }}
        >
          {props.label}
        </InputLabel>
        <Select
          native={true}
          value={props.selectedKey}
          input={
            <OutlinedInput
              id={props.id}
              margin="dense"
              labelWidth={labelWidth}
            />
          }
          onChange={event => {
            const value = event.target.value.toString();

            const areaId = value === "-1" ? undefined : parseInt(value, 10);

            props.onChange(areaId);
          }}
        >
          {!props.onlyShowIncomeLevels ? (
            <>
              <optgroup label="135 LMI Countries">
                <option value="21">All countries</option>
              </optgroup>
              <optgroup label="Income Level">
                {[14, 15, 23].map(key => (
                  <option key={key} value={key.toString()}>
                    {props.areas[key].area}
                  </option>
                ))}
              </optgroup>
              <optgroup label="Donor Priority">
                {[10, 12, 9, 16, 1, 13, 18, 22, 24].map(key => (
                  <option key={key} value={key.toString()}>
                    {props.areas[key].area}
                  </option>
                ))}
              </optgroup>
              <optgroup label="Regional">
                {[5, 3, 2, 4, 6, 8, 7, 11, 17, 19, 20].map(key => (
                  <option key={key} value={key.toString()}>
                    {props.areas[key].area}
                  </option>
                ))}
              </optgroup>
              {props.includeCountries && (
                <optgroup label="Country">
                  {Object.keys(props.areas)
                    .map(key => ({
                      classification: props.areas[key].classification,
                      label: props.areas[key].area,
                      value: key
                    }))
                    .filter(item => item.classification === "Country")
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map(country => (
                      <option key={country.value} value={country.value}>
                        {country.label}
                      </option>
                    ))}
                </optgroup>
              )}
            </>
          ) : (
            <>
              {[14, 15, 23].map(key => (
                <option key={key} value={key.toString()}>
                  {props.areas[key].area}
                </option>
              ))}
            </>
          )}
        </Select>
      </FormControl>
    </form>
  );
};

AreaChooser.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  areas: PropTypes.objectOf(
    PropTypes.shape({
      area: PropTypes.string.isRequired,
      classification: PropTypes.string.isRequired,
      gniGroup: PropTypes.string
    })
  ).isRequired,
  includeCountries: PropTypes.bool,
  onlyShowIncomeLevels: PropTypes.bool,
  selectedKey: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

AreaChooser.defaultProps = {
  label: "Select Country Group",
  includeCountries: false,
  onlyShowIncomeLevels: false
};

export default withStyles(styles)(AreaChooser);
